
import React from 'react';
import Layout from '@/components/Layout/Layout';
import BMICalculator from '@/components/SpecialCalculators/BMICalculator';
import { Link } from 'react-router-dom';

const BMICalculatorPage = () => {
  return (
    <Layout>
      <div className="max-w-5xl mx-auto px-4">
        {/* Header Section */}
        <div className="mb-8">
          <div className="text-sm text-gray-500 mb-2">
            <Link to="/" className="hover:underline">Home</Link> {' > '} 
            <Link to="/special" className="hover:underline">Special Tools</Link> {' > '} 
            <span>BMI Calculator</span>
          </div>
          <h1 className="text-3xl font-bold mb-3">BMI Calculator</h1>
          <p className="text-gray-700">
            Calculate your Body Mass Index (BMI), understand your weight category, and determine your healthy weight range.
          </p>
        </div>

        {/* Calculator Section */}
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 mb-8">
          <BMICalculator />
        </div>

        {/* Information Section */}
        <div className="bg-[#E6F3FF] p-6 rounded-lg mb-8">
          <h2 className="text-2xl font-semibold mb-3">How to use the BMI Calculator</h2>
          <ol className="list-decimal list-inside space-y-2 text-gray-700 ml-2">
            <li>Select your preferred unit system (metric or imperial)</li>
            <li>Enter your weight (in kg or pounds)</li>
            <li>Enter your height (in cm or feet and inches)</li>
            <li>The calculator will automatically compute your BMI, category, and healthy weight range</li>
          </ol>
        </div>

        {/* Additional Information */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">About BMI</h2>
          <p className="text-gray-700 mb-3">
            Body Mass Index (BMI) is a simple calculation using a person's height and weight. The formula is BMI = kg/m² where 
            kg is a person's weight in kilograms and m² is their height in meters squared.
          </p>
          <p className="text-gray-700 mb-3">
            BMI is an indicator of body fatness and is used to screen for weight categories that may lead to health problems. 
            However, BMI does not directly measure body fat, and some factors such as muscle mass can influence the results. 
            Athletes, for example, may have a high BMI due to increased muscle mass rather than body fat.
          </p>
          <p className="text-gray-700 mb-3">
            The BMI ranges are:
          </p>
          <ul className="list-disc list-inside space-y-1 text-gray-700 ml-2">
            <li>Underweight: BMI less than 18.5</li>
            <li>Normal weight: BMI 18.5–24.9</li>
            <li>Overweight: BMI 25–29.9</li>
            <li>Obesity: BMI 30 or greater</li>
          </ul>
          <p className="text-gray-700 mt-3">
            Remember that BMI is just one factor in determining overall health. Consult a healthcare professional for a 
            complete health assessment.
          </p>
        </div>

        {/* Related Calculators */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">Related Calculators</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            <Link to="/special/mortgage" className="p-4 border border-gray-200 rounded-md hover:bg-gray-50 flex items-center">
              <span className="text-xl mr-2">🏠</span> Mortgage Calculator
            </Link>
            <Link to="/special/loan" className="p-4 border border-gray-200 rounded-md hover:bg-gray-50 flex items-center">
              <span className="text-xl mr-2">💰</span> Loan Calculator
            </Link>
            <Link to="/special/tip" className="p-4 border border-gray-200 rounded-md hover:bg-gray-50 flex items-center">
              <span className="text-xl mr-2">🍽️</span> Tip Calculator
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default BMICalculatorPage;
